'use strict';

(function(){

    Fotobook.login = {
        loginIfGuest() {
            if (Fotobook.store.state.user.id) {
                return Promise.resolve();
            }
            if (Fotobook.editor) {
                Fotobook.store.dispatch('bottomPanel/close');
                // Fotobook.bottomPanel.close();
            }

            Fotobook.store.commit('Auth/openLogin');
            return Promise.reject();
        },
    };

})();
